import * as styles from "./RequestsInProgressBar.styles.js";


interface RequestsInProgressBarProps {
  active: boolean;
}

function RequestsInProgressBar({ active }: RequestsInProgressBarProps) {

  if (!active) return null;

  return (
    <div css={styles.base}>
      <div />
      <div />
    </div>
  );
}

export default RequestsInProgressBar;
